import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class StatisticProjectControlling<T extends EMode = EMode.entity> {
  /** Alias: projectCode */
  projectCode?: number;
  /** Alias: ownWorkHoursActual */
  ownWorkHoursActual?: number;
  /** Alias: ownWorkCostsActual */
  ownWorkCostsActual?: number;
  /** Alias: ownWorkFromEstimationCostsEstimated */
  ownWorkFromEstimationCostsEstimated?: number;
  /** Alias: ownWorkFromEstimationHoursEstimated */
  ownWorkFromEstimationHoursEstimated?: number;
  /** Alias: ownWorkFromOfferCostsEstimated */
  ownWorkFromOfferCostsEstimated?: number;
  /** Alias: ownWorkFromOfferHoursEstimated */
  ownWorkFromOfferHoursEstimated?: number;
  /** Alias: ownWorkFromOrderCostsEstimated */
  ownWorkFromOrderCostsEstimated?: number;
  /** Alias: ownWorkFromOrderHoursEstimated */
  ownWorkFromOrderHoursEstimated?: number;
  /** Alias: revenueFromEstimation */
  revenueFromEstimation?: number;
  /** Alias: revenueFromOffer */
  revenueFromOffer?: number;
  /** Alias: revenueFromOrder */
  revenueFromOrder?: number;
  /** Alias: revenueFromInvoice */
  revenueFromInvoice?: number;
  /** Alias: externalWorkFromEstimationCostsEstimated */
  externalWorkFromEstimationCostsEstimated?: number;
  /** Alias: externalWorkFromOfferCostsEstimated */
  externalWorkFromOfferCostsEstimated?: number;
  /** Alias: externalWorkFromOrderCostsEstimated */
  externalWorkFromOrderCostsEstimated?: number;
  /** Alias: externalWorkOpenPurchaseorder */
  externalWorkOpenPurchaseorder?: number;
  /** Alias: externalWorkCostsPlanned */
  externalWorkCostsPlanned?: number;
  /** Alias: externalWorkCostsActual */
  externalWorkCostsActual?: number;
  /** Alias: proformaIncomingInvoice */
  proformaIncomingInvoice?: number;

  __typename?: string;
}

const fields: FieldDefinitions<StatisticProjectControlling> = {
  projectCode: {
    alias: 'projectCode',
  },
  ownWorkHoursActual: {
    alias: 'ownWorkHoursActual',
  },
  ownWorkCostsActual: {
    alias: 'ownWorkCostsActual',
  },
  ownWorkFromEstimationCostsEstimated: {
    alias: 'ownWorkFromEstimationCostsEstimated',
  },
  ownWorkFromEstimationHoursEstimated: {
    alias: 'ownWorkFromEstimationHoursEstimated',
  },
  ownWorkFromOfferCostsEstimated: {
    alias: 'ownWorkFromOfferCostsEstimated',
  },
  ownWorkFromOfferHoursEstimated: {
    alias: 'ownWorkFromOfferHoursEstimated',
  },
  ownWorkFromOrderCostsEstimated: {
    alias: 'ownWorkFromOrderCostsEstimated',
  },
  ownWorkFromOrderHoursEstimated: {
    alias: 'ownWorkFromOrderHoursEstimated',
  },
  revenueFromEstimation: {
    alias: 'revenueFromEstimation',
  },
  revenueFromOffer: {
    alias: 'revenueFromOffer',
  },
  revenueFromOrder: {
    alias: 'revenueFromOrder',
  },
  revenueFromInvoice: {
    alias: 'revenueFromInvoice',
  },
  externalWorkFromEstimationCostsEstimated: {
    alias: 'externalWorkFromEstimationCostsEstimated',
  },
  externalWorkFromOfferCostsEstimated: {
    alias: 'externalWorkFromOfferCostsEstimated',
  },
  externalWorkFromOrderCostsEstimated: {
    alias: 'externalWorkFromOrderCostsEstimated',
  },
  externalWorkOpenPurchaseorder: {
    alias: 'externalWorkOpenPurchaseorder',
  },
  externalWorkCostsPlanned: {
    alias: 'externalWorkCostsPlanned',
  },
  externalWorkCostsActual: {
    alias: 'externalWorkCostsActual',
  },
  proformaIncomingInvoice: {
    alias: 'proformaIncomingInvoice',
  },
  __typename: {
    alias: '__typename',
  },
};

export const statisticProjectControllingEntityDefinition: EntitiyDefinition<StatisticProjectControlling> =
  {
    local: {},
    remote: {
      queryName: 'getProjectControlling',
      fragmentName: 'StatisticProjectControlling',
      withPaginationWrapper: false,
      params: [
        { name: 'rangeStart', type: 'Date' },
        { name: 'rangeEnd', type: 'Date' },
        { name: 'projectGroupFilter', type: '[Int]' },
        { name: 'projectFilter', type: '[Int]' },
      ],
    },
    fieldDefinitions: fields,
  };
